import { useCentrixApi } from "core/hooks/useCentrixApi";
import { useLocale } from "core/hooks/useLocale";

export function useNewsEventsTags(type: "news" | "events") {
  const locale = useLocale();
  return useCentrixApi({
    path: "/api/news-events/articles-v2/Tags",
    parameters: { query: { Locale: locale, Type: type } },
  });
}
